import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from 'rxjs';
import axios from "axios";
import { ProductType } from "src/app/services/product-service/product-service.service";
import { environment } from "src/environments/environment";
import { StateNode } from "./state-node/state-node";
import { WorkflowProcess } from "./types";

export const partners = [
  'any',
  'stripe',
] as const;
export type Partner = typeof partners[number];

@Injectable({
  providedIn: 'root'
})
export class WorkflowEditorService {
  readonly stateChange = new Subject<{ node: StateNode, selected: boolean; }>();

  readonly forceExpand = new BehaviorSubject<boolean | undefined>(true);
  readonly fogOfWar = new BehaviorSubject<boolean>(true);
  readonly showInfoNotifications = new BehaviorSubject<boolean>(true);
  readonly immersiveCanvas = new BehaviorSubject<boolean>(false);

  async getWorkflowProcess(
    product: ProductType,
    partner: Partner,
  ): Promise<WorkflowProcess> {
    const result = await axios.get<{ process: WorkflowProcess; }>(`${environment.baseUrl}/api/workflow-process`, {
      params: {
        partner: partner === 'any'
          ? null
          : partner,
        product: product,
      },
    });
    return result.data.process;
  }
}